export default {
  title: "Zeitplan",
  subtitle: "Organisiere den Ablauf deines Hochzeitstages",
  description: "Plane jeden Moment deines besonderen Tages",
  addEvent: "Ereignis hinzufügen",
  editEvent: "Ereignis bearbeiten",
  deleteEvent: "Ereignis löschen",
  confirmDeleteEvent: "Bist du sicher, dass du dieses Ereignis löschen möchtest?",
  eventDeleted: "Ereignis erfolgreich gelöscht",
  eventCreated: "Ereignis erfolgreich erstellt",
  eventUpdated: "Ereignis erfolgreich aktualisiert",
  noEvents: "Keine Ereignisse gefunden",
  totalEvents: "{{count}} Ereignisse",
  filterByCategory: "Nach Kategorie filtern",
  allCategories: "Alle Kategorien",
  emptyState: {
    title: "Dein Zeitplan ist leer",
    description: "Plane die Ereignisse deines Hochzeitstages",
    action: "Ereignis hinzufügen"
  },
  timespan: "{{start}} - {{end}}",
  form: {
    title: "Titel",
    titlePlaceholder: "Titel des Ereignisses",
    description: "Beschreibung",
    descriptionPlaceholder: "Beschreibung des Ereignisses",
    startTime: "Startzeit",
    endTime: "Endzeit",
    location: "Ort",
    locationPlaceholder: "Ort des Ereignisses",
    category: "Kategorie",
    categoryPlaceholder: "Kategorie des Ereignisses",
    notes: "Notizen",
    notesPlaceholder: "Zusätzliche Notizen",
    name: "Nachname",
    submit: "Speichern",
    cancel: "Abbrechen"
  },
  categories: {
    preparation: "Vorbereitung",
    ceremony: "Zeremonie",
    reception: "Empfang",
    party: "Feier",
    other: "Sonstiges",
    photo: "Fotos",
    task: "Aufgabe",
    vendor: "Dienstleister",
    reminder: "Erinnerung",
    custom: "Benutzerdefiniert",
    photos: "Fotos",
    entertainment: "Unterhaltung",
    meal: "Mahlzeit",
    transportation: "Transport",
    select: "Kategorie auswählen",
    religious_venue: "Gotteshaus",
    city_hall: "Rathaus",
    none: "Keine"
  },
  actions: {
    add: "Hinzufügen",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    addEvent: "Ereignis hinzufügen",
    share: "Teilen",
    useExample: "Vorlage verwenden",
    addExamples: "Beispiele hinzufügen",
    addingExamples: "Beispiele werden hinzugefügt..."
  },
  errors: {
    loadEvents: "Fehler beim Laden der Ereignisse",
    createEvent: "Fehler beim Erstellen des Ereignisses",
    updateEvent: "Fehler beim Aktualisieren des Ereignisses",
    deleteEvent: "Fehler beim Löschen des Ereignisses",
    noWeddingFound: "Keine Hochzeit gefunden",
    createWeddingFirst: "Bitte erstellen Sie zuerst eine Hochzeit",
    addEvent: "Fehler beim Hinzufügen des Ereignisses",
    addExampleEvents: "Fehler beim Hinzufügen von Beispielereignissen"
  },
  examples: {
    preparation: {
      title: "Vorbereitung",
      description: "Vorbereitung von Braut und Bräutigam und Einkleiden"
    },
    ceremony: {
      title: "Zeremonie",
      description: "Zivile oder religiöse Zeremonie"
    },
    cocktail: {
      title: "Cocktail",
      description: "Ehrenwein und Fotos"
    },
    lunch: {
      title: "Mittagessen / Abendessen",
      description: "Hochzeitsessen"
    },
    speeches: {
      title: "Reden",
      description: "Reden der Trauzeugen und der Familie"
    },
    cake: {
      title: "Torte",
      description: "Anschneiden der Torte und Champagner"
    },
    party: {
      title: "Party",
      description: "Eröffnungstanz und Tanzparty"
    },
    dinner: {
      title: "Abendessen",
      description: "Hauptmahlzeit für alle Gäste"
    },
    firstDance: {
      title: "Erster Tanz",
      description: "Erster Tanz des frisch vermählten Paares"
    },
    cakeCutting: {
      title: "Anschneiden der Torte",
      description: "Traditionelles Anschneiden der Hochzeitstorte"
    },
    guestsArrival: {
      title: "Ankunft der Gäste",
      description: "Die Gäste treffen am Veranstaltungsort ein"
    },
    dancing: {
      title: "Tanzparty",
      description: "Die Tanzfläche ist eröffnet"
    }
  },
  sharing: {
    recipientEmail: "Empfänger-E-Mail",
    emailPlaceholder: "beispiel@email.com",
    recipientName: "Empfänger-Name",
    namePlaceholder: "Name",
    message: "Nachricht",
    messagePlaceholder: "Ihre Nachricht...",
    send: "Senden",
    cancel: "Abbrechen",
    title: "Zeitplan teilen"
  },
  addFirstEvent: "Fügen Sie Ihr erstes Ereignis hinzu",
  titlePlaceholder: "Name der Veranstaltung",
  descriptionPlaceholder: "Veranstaltungsbeschreibung",
  durationLabel: "Dauer",
  timelineWidget: {
    title: "Zeitleiste",
    subtitle: "Kommende Veranstaltungen",
    empty: "Keine kommenden Veranstaltungen"
  },
  filters: {
    category: "Kategorie",
    date: "Datum",
    search: "Suche nach einem Ereignis",
    clear: "Filter löschen",
    apply: "Anwenden",
    previous: "Vorherige",
    next: "Nächste"
  },
  status: {
    scheduled: "Geplant",
    confirmed: "Bestätigt",
    completed: "Beendet",
    cancelled: "Abgesagt",
    delayed: "Verzögert",
    in_progress: "In Bearbeitung"
  },
  participants: "Teilnehmer",
  reminders: "Erinnerungen",
  minutesAbbr: "min",
  duration: "Dauer",
  empty: {
    title: "Kein Ereignis",
    description: "Beginnen Sie mit der Planung Ihres Tages, indem Sie Ereignisse hinzufügen."
  },
  delete: {
    title: "Ereignis löschen",
    confirmation: "Möchten Sie dieses Ereignis wirklich löschen? Diese Aktion ist irreversibel."
  },
  aria: {
    addEvent: "Ereignis hinzufügen",
    edit: "Ereignis bearbeiten",
    delete: "Ereignis löschen"
  },
  messages: {
    createSuccess: "Ereignis erfolgreich hinzugefügt",
    updateSuccess: "Ereignis erfolgreich aktualisiert",
    deleteSuccess: "Ereignis erfolgreich gelöscht",
    deleteConfirm: "Möchten Sie dieses Ereignis wirklich löschen?",
    error: "Ein Fehler ist aufgetreten"
  },
  modal: {
    title: "Ereignis",
    edit: "Ereignis bearbeiten",
    delete: "Ereignis löschen",
    confirmDelete: "Möchten Sie dieses Ereignis wirklich löschen?"
  },
  view: {
    day: "Tag",
    week: "Woche",
    month: "Monat",
    today: "Heute",
    daysLeft: "{{count}} Tage verbleibend",
    upcoming: "Kommend"
  }
};
